|NEW_FILE_CODE
<template>
	<div class="add-opinion-page">
<!--		<div class="page-header">-->
<!--			<h2>添加意见</h2>-->
<!--			<el-button style="margin-right: 30px" @click="goBack" type="primary">返回</el-button>-->
<!--		</div>-->
<!--		-->
		<el-dialog
				:modal-append-to-body="false"
				:visible.sync="dialog"
				v-model="dialog"
				:fullscreen="true"
				:close-on-click-modal="false"
				:destroy-on-close="true"
				width='90%'
				:show-close="false"
		>
			<div style="margin: 0 auto;">
				<PdfScreenshotViewer
						:pdf-url="pdfUrl"
						:needDataItem="drawingData"
						:initial-zoom="1"
				/>
			</div>
		</el-dialog>
<!--		<div class="pdf-viewer-container">-->
<!--			<PdfScreenshotViewer-->
<!--					:pdf-url="pdfUrl"-->
<!--					:needDataItem="drawingData"-->
<!--					:initial-zoom="1"-->
<!--			/>-->
<!--		</div>-->
		<div style="height: 20px">
		</div>
	</div>
</template>

<script>
import PdfScreenshotViewer from '../components/NewPdfScreenshotViewer.vue';
import { generateTemporaryUrlByFileName } from '@/api/api';

export default {
	name: 'AddOpinionPage',
	components: {
		PdfScreenshotViewer
	},
	data() {
		return {
			dialog:true,
			pdfUrl: '',
			drawingData: null
		};
	},
	created() {
		// 从路由参数获取数据
		const data = JSON.parse(this.$route.query.data);
		console.log('data:', data);
		if (data) {
			this.drawingData = data;
			this.pdfUrl = this.$route.query.pdfUrl;
			// 设置浏览器标题（优先使用传递的 projectName）
			const projectName = this.$route.query.projectName || data.projectName || data.fileName || '添加审查意见';
			document.title = `${projectName} - 消防安全检查AI人工智能审查系统`;
			this.loadPdf();
		} else {
			this.$message.error('未找到图纸数据');
		}
	},
	methods: {
		
		async loadPdf() {
			if (!this.drawingData || !this.drawingData.filePath) {
				this.$message.error('图纸路径无效');
				return;
			}
			
			try {
				const params = {
					fileName: this.drawingData.filePath.split('.com/')[1]
				};
				const res = await generateTemporaryUrlByFileName(params);
				if (res.data) {
					this.pdfUrl = res.data;
				}
			} catch (error) {
				console.error('加载 PDF 失败:', error);
				this.$message.error('加载 PDF 失败，请重试');
			}
		},
		goBack() {
			this.$router.go(-1);
		}
	}
};
</script>

<style scoped>

>>> .el-dialog__header{
	padding:0;
}
>>> .el-dialog__body{
	padding:0;
}
.add-opinion-page {
	padding: 20px;
	height: 100vh;
	display: flex;
	flex-direction: column;
}

.page-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 20px;
	padding-bottom: 15px;
	border-bottom: 1px solid #e6e6e6;
}

.page-header h2 {
	margin: 0;
	font-size: 20px;
	color: #333;
}

.pdf-viewer-container {
	flex: 1;
	overflow: hidden;
	background: #f5f5f5;
	border-radius: 4px;
	padding: 20px;
}
</style>
